module.exports = __webpack_public_path__ + "img/Questions_Mobile.d6941fb7.svg";